import { default as index7YrxoTyuA2Meta } from "D:/Out/MedCAT/medcat.cms/pages/account/index.vue?macro=true";
import { default as loginCRwOcT5hfYMeta } from "D:/Out/MedCAT/medcat.cms/pages/account/login.vue?macro=true";
import { default as settingskT5Mf97kHaMeta } from "D:/Out/MedCAT/medcat.cms/pages/account/settings.vue?macro=true";
import { default as indexg2MWgPz7DaMeta } from "D:/Out/MedCAT/medcat.cms/pages/activity-log/index.vue?macro=true";
import { default as _91id_93nA6WItsZxtMeta } from "D:/Out/MedCAT/medcat.cms/pages/admin/form-config/[id].vue?macro=true";
import { default as indexHY5GUu6oIMMeta } from "D:/Out/MedCAT/medcat.cms/pages/admin/form-config/index.vue?macro=true";
import { default as indexGhO4dXRNgrMeta } from "D:/Out/MedCAT/medcat.cms/pages/app/index.vue?macro=true";
import { default as builder90vlSkrSgSMeta } from "D:/Out/MedCAT/medcat.cms/pages/builder.vue?macro=true";
import { default as _91code_93ulecqxunzbMeta } from "D:/Out/MedCAT/medcat.cms/pages/category/[code].vue?macro=true";
import { default as indexV8zExk4pKOMeta } from "D:/Out/MedCAT/medcat.cms/pages/chat/index.vue?macro=true";
import { default as indexxNCiheaLkrMeta } from "D:/Out/MedCAT/medcat.cms/pages/company/index.vue?macro=true";
import { default as _91id_93UXhY33UF6SMeta } from "D:/Out/MedCAT/medcat.cms/pages/contract/[id].vue?macro=true";
import { default as _91id_93ZPi7oZbSKlMeta } from "D:/Out/MedCAT/medcat.cms/pages/contract/document/[id].vue?macro=true";
import { default as index8x4GVWQpIlMeta } from "D:/Out/MedCAT/medcat.cms/pages/contract/index.vue?macro=true";
import { default as indexEQxu2uXgwWMeta } from "D:/Out/MedCAT/medcat.cms/pages/customer/index.vue?macro=true";
import { default as prescription_45dynamici3gMekHLAVMeta } from "D:/Out/MedCAT/medcat.cms/pages/demo/prescription-dynamic.vue?macro=true";
import { default as indexIeOmd2etrnMeta } from "D:/Out/MedCAT/medcat.cms/pages/document-pending/index.vue?macro=true";
import { default as indexsPwYhu6zh6Meta } from "D:/Out/MedCAT/medcat.cms/pages/documents/index.vue?macro=true";
import { default as indexzHjimIppi4Meta } from "D:/Out/MedCAT/medcat.cms/pages/facility/index.vue?macro=true";
import { default as indexRKiRgaGXyCMeta } from "D:/Out/MedCAT/medcat.cms/pages/index.vue?macro=true";
import { default as indexsWx7X4qP14Meta } from "D:/Out/MedCAT/medcat.cms/pages/original-document/index.vue?macro=true";
import { default as _91id_93v0iCkrBW9cMeta } from "D:/Out/MedCAT/medcat.cms/pages/payment-request/csyt/[id].vue?macro=true";
import { default as indexZo8CJR6CAjMeta } from "D:/Out/MedCAT/medcat.cms/pages/payment-request/csyt/index.vue?macro=true";
import { default as _91id_93mcTHC1RyHkMeta } from "D:/Out/MedCAT/medcat.cms/pages/payment-request/ctbh/[id].vue?macro=true";
import { default as indexWiXm8qtFp7Meta } from "D:/Out/MedCAT/medcat.cms/pages/payment-request/ctbh/index.vue?macro=true";
import { default as indexyBXfHMmcfvMeta } from "D:/Out/MedCAT/medcat.cms/pages/payment-request/index.vue?macro=true";
import { default as indextX7bdYbvRfMeta } from "D:/Out/MedCAT/medcat.cms/pages/role/index.vue?macro=true";
import { default as indexX5yFnxqKvbMeta } from "D:/Out/MedCAT/medcat.cms/pages/system-config/index.vue?macro=true";
import { default as file_45managerLNgpQAduYOMeta } from "D:/Out/MedCAT/medcat.cms/pages/test/file-manager.vue?macro=true";
import { default as file_45viewerd7XVmBJNQzMeta } from "D:/Out/MedCAT/medcat.cms/pages/test/file-viewer.vue?macro=true";
import { default as pdf2imagezUwa13bWMOMeta } from "D:/Out/MedCAT/medcat.cms/pages/test/pdf2image.vue?macro=true";
import { default as testxL69uhPZauMeta } from "D:/Out/MedCAT/medcat.cms/pages/test.vue?macro=true";
import { default as test2GsXF3Y5qkjMeta } from "D:/Out/MedCAT/medcat.cms/pages/test2.vue?macro=true";
import { default as _91id_93tOjwmXfGZtMeta } from "D:/Out/MedCAT/medcat.cms/pages/user-report/[id].vue?macro=true";
import { default as indexLpkzR1BlITMeta } from "D:/Out/MedCAT/medcat.cms/pages/user-report/index.vue?macro=true";
export default [
  {
    name: "account___vi",
    path: "/account",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: loginCRwOcT5hfYMeta || {},
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginCRwOcT5hfYMeta || {},
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/account/login.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/account/settings.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/activity-log/index.vue")
  },
  {
    name: "admin-form-config-id___vi",
    path: "/admin/form-config/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/admin/form-config/[id].vue")
  },
  {
    name: "admin-form-config-id___en",
    path: "/en/admin/form-config/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/admin/form-config/[id].vue")
  },
  {
    name: "admin-form-config___vi",
    path: "/admin/form-config",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/admin/form-config/index.vue")
  },
  {
    name: "admin-form-config___en",
    path: "/en/admin/form-config",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/admin/form-config/index.vue")
  },
  {
    name: "app___vi",
    path: "/app",
    meta: indexGhO4dXRNgrMeta || {},
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/app/index.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    meta: indexGhO4dXRNgrMeta || {},
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/app/index.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/builder.vue")
  },
  {
    name: "category-code___vi",
    path: "/category/:code()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/category/[code].vue")
  },
  {
    name: "category-code___en",
    path: "/en/category/:code()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/category/[code].vue")
  },
  {
    name: "chat___vi",
    path: "/chat",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/chat/index.vue")
  },
  {
    name: "chat___en",
    path: "/en/chat",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/chat/index.vue")
  },
  {
    name: "company___vi",
    path: "/company",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/company/index.vue")
  },
  {
    name: "company___en",
    path: "/en/company",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/company/index.vue")
  },
  {
    name: "contract-id___vi",
    path: "/contract/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/contract/[id].vue")
  },
  {
    name: "contract-id___en",
    path: "/en/contract/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/contract/[id].vue")
  },
  {
    name: "contract-document-id___vi",
    path: "/contract/document/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/contract/document/[id].vue")
  },
  {
    name: "contract-document-id___en",
    path: "/en/contract/document/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/contract/document/[id].vue")
  },
  {
    name: "contract___vi",
    path: "/contract",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/contract/index.vue")
  },
  {
    name: "contract___en",
    path: "/en/contract",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/contract/index.vue")
  },
  {
    name: "customer___vi",
    path: "/customer",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/customer/index.vue")
  },
  {
    name: "customer___en",
    path: "/en/customer",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/customer/index.vue")
  },
  {
    name: "demo-prescription-dynamic___vi",
    path: "/demo/prescription-dynamic",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/demo/prescription-dynamic.vue")
  },
  {
    name: "demo-prescription-dynamic___en",
    path: "/en/demo/prescription-dynamic",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/demo/prescription-dynamic.vue")
  },
  {
    name: "document-pending___vi",
    path: "/document-pending",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/document-pending/index.vue")
  },
  {
    name: "document-pending___en",
    path: "/en/document-pending",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/document-pending/index.vue")
  },
  {
    name: "documents___vi",
    path: "/documents",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/documents/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/documents/index.vue")
  },
  {
    name: "facility___vi",
    path: "/facility",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/facility/index.vue")
  },
  {
    name: "facility___en",
    path: "/en/facility",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/facility/index.vue")
  },
  {
    name: "index___vi",
    path: "/",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/index.vue")
  },
  {
    name: "original-document___vi",
    path: "/original-document",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/original-document/index.vue")
  },
  {
    name: "original-document___en",
    path: "/en/original-document",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/original-document/index.vue")
  },
  {
    name: "payment-request-csyt-id___vi",
    path: "/payment-request/csyt/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/csyt/[id].vue")
  },
  {
    name: "payment-request-csyt-id___en",
    path: "/en/payment-request/csyt/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/csyt/[id].vue")
  },
  {
    name: "payment-request-csyt___vi",
    path: "/payment-request/csyt",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/csyt/index.vue")
  },
  {
    name: "payment-request-csyt___en",
    path: "/en/payment-request/csyt",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/csyt/index.vue")
  },
  {
    name: "payment-request-ctbh-id___vi",
    path: "/payment-request/ctbh/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/ctbh/[id].vue")
  },
  {
    name: "payment-request-ctbh-id___en",
    path: "/en/payment-request/ctbh/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/ctbh/[id].vue")
  },
  {
    name: "payment-request-ctbh___vi",
    path: "/payment-request/ctbh",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/ctbh/index.vue")
  },
  {
    name: "payment-request-ctbh___en",
    path: "/en/payment-request/ctbh",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/ctbh/index.vue")
  },
  {
    name: "payment-request___vi",
    path: "/payment-request",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/index.vue")
  },
  {
    name: "payment-request___en",
    path: "/en/payment-request",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/payment-request/index.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/role/index.vue")
  },
  {
    name: "system-config___vi",
    path: "/system-config",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/system-config/index.vue")
  },
  {
    name: "system-config___en",
    path: "/en/system-config",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/system-config/index.vue")
  },
  {
    name: "test___vi",
    path: "/test",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test.vue"),
    children: [
  {
    name: "test-file-manager___vi",
    path: "file-manager",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___vi",
    path: "file-viewer",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "pdf2image",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test/pdf2image.vue")
  }
]
  },
  {
    name: "test___en",
    path: "/en/test",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test.vue"),
    children: [
  {
    name: "test-file-manager___en",
    path: "file-manager",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___en",
    path: "file-viewer",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "pdf2image",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test/pdf2image.vue")
  }
]
  },
  {
    name: "test2___vi",
    path: "/test2",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test2.vue")
  },
  {
    name: "test2___en",
    path: "/en/test2",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/test2.vue")
  },
  {
    name: "user-report-id___vi",
    path: "/user-report/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/user-report/[id].vue")
  },
  {
    name: "user-report-id___en",
    path: "/en/user-report/:id()",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/user-report/[id].vue")
  },
  {
    name: "user-report___vi",
    path: "/user-report",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/user-report/index.vue")
  },
  {
    name: "user-report___en",
    path: "/en/user-report",
    component: () => import("D:/Out/MedCAT/medcat.cms/pages/user-report/index.vue")
  }
]